
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_17r07_43",
  "spinner-rotator": "awsui_spinner-rotator_1612d_17r07_1",
  "size-x-small": "awsui_size-x-small_1612d_17r07_57",
  "size-normal": "awsui_size-normal_1612d_17r07_64",
  "size-big": "awsui_size-big_1612d_17r07_71",
  "size-large": "awsui_size-large_1612d_17r07_78",
  "variant-normal": "awsui_variant-normal_1612d_17r07_85",
  "variant-disabled": "awsui_variant-disabled_1612d_17r07_88",
  "variant-inverted": "awsui_variant-inverted_1612d_17r07_91",
  "circle": "awsui_circle_1612d_17r07_106",
  "circle-left": "awsui_circle-left_1612d_17r07_134",
  "spinner-line-left": "awsui_spinner-line-left_1612d_17r07_1",
  "circle-right": "awsui_circle-right_1612d_17r07_139",
  "spinner-line-right": "awsui_spinner-line-right_1612d_17r07_1"
};
  